const BASE_URL = "https://admin.bossdentindia.com/wp-json/custom/v1";

export default BASE_URL;